import { ModalControls } from "../../../../customHooks/useModalControl";
import {
  formatToCurrency,
  formatToNumber,
  getOffsetFromPage,
  getPageFromOffset,
  parseStringToNumber,
} from "../../../../helperFunctions";
import {
  LoanRequestApprovalQuery,
  LoanRequestApprovalsResponse,
} from "../../../../redux/features/approvals/approvals.type";
import { SingleLoan } from "../../../../redux/features/loans/loans.type";
import { ApprovalActionDetails } from "../../../../utils/types";
import { TableComponent } from "../../table";

export const SingleLoanRequestApproval = ({
  modalControls,
  setSelectedIds,
  selectedIds,
  approvals,
  setActionDetails,
  setSelectedEntry,
  fetching,
  query,
  setQuery,
}: {
  modalControls: ModalControls;
  selectedIds: number[];
  setSelectedIds: (v: number[]) => void;
  approvals?: LoanRequestApprovalsResponse;
  setActionDetails: (v: ApprovalActionDetails) => void;
  setSelectedEntry: (v: SingleLoan) => void;
  fetching: boolean;
  query: LoanRequestApprovalQuery;
  setQuery: (v: LoanRequestApprovalQuery) => void;
}) => {
  const { handleModalOpen } = modalControls;

  return (
    <TableComponent
      mobileCardView
      headers={["Member", "Loan Type", "Loan Amount", "Tenor"]}
      headerActionProps={{
        hasActions: true,
        hasCheckbox: true,
        checked:
          selectedIds.length > 0 &&
          selectedIds.length === approvals?.data?.results?.length,
        onCheck: () => {
          setSelectedIds(approvals?.data?.results?.map((i) => i.id) ?? []);
        },
        onUncheck: () => {
          setSelectedIds([]);
        },
        hasMoreMenu: true,
      }}
      rows={
        approvals?.data?.results?.map((entry, idx) => {
          return {
            id: entry.id,
            onClick: () => {
              if (selectedIds.includes(entry.id)) {
                setSelectedIds(selectedIds.filter((i) => i !== entry.id));
              } else {
                setSelectedIds([...selectedIds, entry.id]);
              }
            },
            items: [
              <p className="min-w-fit whitespace-nowrap">
                {entry?.MemberID?.User?.FirstName}{" "}
                {entry?.MemberID?.User?.LastName}
              </p>,
              entry?.LoanProduct?.LoanName,
              formatToCurrency(entry?.Amount, {
                decimalPlaces: 2,
                currency: "NGN",
              }),
              `${formatToNumber(entry?.Tenure, {
                decimalPlaces: 0,
              })} ${
                parseStringToNumber(entry?.Tenure) === 1 ? "month" : "months"
              }`,
            ],
            actionProps: {
              hasActions: true,
              hasCheckbox: true,
              checked: selectedIds.includes(entry.id),
              onCheck: () => {},
              onUncheck: () => {},
              hasMoreMenu: true,
              moreOptions: [
                {
                  icon: "coins-hand",
                  text: "View Loan Details",
                  onClick: () => {
                    setSelectedEntry(entry);
                    handleModalOpen("loanDetailsModal");
                  },
                },
                {
                  icon: "verified-icon",
                  text: "Accept",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: true,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
                {
                  icon: "close-icon",
                  text: "Decline",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: false,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
              ],
            },
          };
        }) ?? []
      }
      stickyLastCol
      isRowClickable={true}
      onRowClick={() => {}}
      isTableEmpty={[0, undefined].includes(approvals?.data?.results?.length)}
      emptyTitle="No Pending Approvals"
      isLoading={fetching}
      isPaginated
      currentPage={getPageFromOffset(query.offset!, query.limit!)}
      totalCount={approvals?.data?.count}
      itemsPerPage={query.limit}
      onPageChange={(page) => {
        setQuery({
          ...query,
          offset: getOffsetFromPage(page, query.limit!),
        });
        setSelectedIds([]);
      }}
    />
  );
};
